import * as React from 'react';

export interface IEditableEpiProperty {
    property: any;
    propertyName: string;
    wrappingElement: string;
    isInEditMode: boolean;
}

export function renderEditableEpiProperty(editableEpiProperty: IEditableEpiProperty) {
    if (editableEpiProperty.isInEditMode) {
        return React.createElement(
            editableEpiProperty.wrappingElement,
            { 'data-epi-property-name': editableEpiProperty.propertyName, 'data-epi-use-mvc': 'True' },
            editableEpiProperty.property
        );
    } else {
        return editableEpiProperty.property;
    }
}  
